import React, { useEffect, useRef, useState } from "react";
import Header from "../Core/Header";
import Footer from "../Core/Footer";
import { useNavigate, useParams } from "react-router-dom";
import {
  bookingDetails,
  getProfile,
  termConcition,
} from "../../service/operations/api_methods";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "sonner";
import { details } from "motion/react-client";
import { useMediaQuery } from "usehooks-ts";

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const Tickit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token =
    useSelector((state) => state.auth.token) || Cookies.get("roam-token");
  const sectionRef = useRef();
  const [deatil, setDetail] = useState(null);
  const [load, setLoad] = useState(false);

  const mobile = useMediaQuery("(max-width: 767px)");
  const [name, setName] = useState("");
  const [termsData, setTermsData] = useState("");

  const handleBookingDetails = async () => {
    try {
      const response = await bookingDetails({ token, id });
      console.log(response);
      if (response.status === 200) {
        setDetail(response.data.booking);
        toast.success("Ticket Created successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetProfile = async () => {
    try {
      const response = await getProfile(token);
      console.log("profile", response);
      if (response.status === 200) {
        setName(response.data.user.name);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getTermCondition = async () => {
    try {
      const response = await termConcition(token);
      console.log(response);
      setTermsData(response.data.terms.content);
    } catch (error) {
      console.log(error);
    }
  };

  const download = async () => {
    if (deatil.paymentStatus !== "success") {
      toast.info("Make payment to download ticket");
      return;
    }

    setLoad(true);

    try {
      const element = sectionRef.current;

      // 🔥 Force full expansion (no scroll anywhere)
      const allScrollable = element.querySelectorAll("*");

      allScrollable.forEach((el) => {
        el._overflow = el.style.overflow;
        el._maxHeight = el.style.maxHeight;

        el.style.overflow = "visible";
        el.style.maxHeight = "none";
      });

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const pdfWidth = pageWidth * 0.9;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = pdfHeight;
      let position = 0;

      // First page
      pdf.addImage(
        imgData,
        "PNG",
        (pageWidth - pdfWidth) / 2,
        position,
        pdfWidth,
        pdfHeight,
      );

      heightLeft -= pageHeight;

      // Extra pages
      while (heightLeft > 0) {
        position -= pageHeight;

        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          (pageWidth - pdfWidth) / 2,
          position,
          pdfWidth,
          pdfHeight,
        );

        heightLeft -= pageHeight;
      }

      pdf.save("ticket.pdf");

      // 🔁 Restore styles
      allScrollable.forEach((el) => {
        el.style.overflow = el._overflow || "";
        el.style.maxHeight = el._maxHeight || "";
      });
    } catch (err) {
      console.error(err);
    }

    setLoad(false);
  };
  const handlePayment = async (bookingId) => {
    // 1️⃣ Load Razorpay SDK
    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    try {
      // 2️⃣ Call backend to create order
      const { data } = await axios.post(
        "https://admin.roamjssln.com/api/payments/create-order",
        {
          bookingId: bookingId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      console.log(data);

      // 3️⃣ Configure Razorpay payment options
      const options = {
        key: data.key, // Replace with your test key
        amount: data.order.amount,
        currency: data.order.currency,
        name: "Siance Software",
        description: "Test Transaction",
        order_id: data.order.id,
        handler: async function (response) {
          // Payment successful
          const { razorpay_payment_id, razorpay_order_id, razorpay_signature } =
            response;
          try {
            // 4️⃣ Verify payment with backend
            const verifyRes = await axios.post(
              "https://admin.roamjssln.com/api/payments/verify",
              {
                razorpay_order_id,
                razorpay_payment_id,
                razorpay_signature,
                bookingId,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (verifyRes.data.success) {
              toast.success("payment verified successfully");
              window.location.reload();
            } else {
              alert("❌ Payment verification failed!");
              navigate("/myprofile");
            }
          } catch (err) {
            console.error("Verification error:", err);
            alert("Error verifying payment. Please contact support.");
          }

          // Optional: verify payment with backend here
        },
        prefill: {
          name: "John Doe",
          email: "john@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#3399cc",
        },
      };

      // 4️⃣ Open Razorpay checkout modal
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      console.error(err);
      alert("Payment failed. Check console for details.");
    }
  };

  useEffect(() => {
    handleBookingDetails();
    handleGetProfile();
    getTermCondition();
  }, []);

  return (
    <div>
      <div style={{ backgroundColor: "white" }}>
        <Header />
      </div>
      <p
        style={{
          backgroundColor: "#ffffffff",
          textAlign: "center",
          fontSize: "25px",
          fontWeight: "700",
        }}
      >
        Here is Your Ticket !
      </p>
      <button
        onClick={download}
        style={{
          backgroundColor:
            deatil?.paymentStatus !== "success" ? "#90bcf5ff" : "#1e7cf8ff",
          color: "white",
          border: "none",
          padding: "8px",
          borderRadius: "10px",
          cursor:
            deatil?.paymentStatus !== "success" ? "not-allowed" : "pointer",
          top: "100px",
          right: "20px",
          position: "absolute",
        }}
      >
        {load ? "proccessing.." : "Download"}
      </button>

      <div
        ref={sectionRef}
        id="download-section"
        style={{
          width: "100vw",
          height: "fit-content",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          justifyContent: "left",
          padding: mobile ? "10px" : "5vh 5vw",
        }}
      >
        {deatil && (
          <div
            style={{
              width: "100%",
              border: "1px solid gray",
              padding: "10px",
              borderRadius: "10px",
              height: "fit-content",
              minHeight: "fit-content",
              maxHeight: "50vh",
              overflowY: "auto",
              overflowX: "hidden",
              backgroundColor: "#abf0fc",
            }}
          >
            <div
              className="logo"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                style={{
                  borderBottom: "0.5px solid #085080",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  width: "100%",
                  flexWrap: "wrap", // 🔥 important
                }}
              >
                {/* Logo Section */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <img
                    src="/Assets/title-logo.png"
                    style={{ width: "25px", height: "22px" }}
                  />
                  <img
                    src="/Assets/logo.png"
                    style={{ width: "60px", height: "18px" }}
                  />
                </div>

                {/* Text Section */}
                <div style={{ flex: "1 1 100%", textAlign: "center" }}>
                  <p
                    style={{
                      fontSize: "clamp(16px, 4vw, 20px)", // 🔥 responsive font
                      color: "#085080",
                      margin: "4px 0",
                    }}
                  >
                    Ticket Information
                  </p>

                  <p
                    style={{
                      fontSize: "clamp(12px, 3vw, 14px)",
                      color: "#085080",
                      fontWeight: "500",
                      margin: "0",
                      overflowWrap: "break-word", // 🔥 MOST IMPORTANT
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {deatil?.boardingPoint?.name} -{" "}
                    {deatil?.droppingPoint?.name} on{" "}
                    {deatil?.journeyDetails?.dayOfWeek},{" "}
                    {new Date(
                      deatil?.journeyDetails?.date,
                    ).toLocaleDateString()}{" "}
                    | {deatil?.isInstantBooking ? "BOOKING NO:" : "PNR NO:"}
                    {deatil?.pnr}
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                margin: "14px",
                fontSize: "14px",
              }}
            >
              <p> Hey {name},</p>
              <br />
              <p>
                Thank you for booking your bus ticket with ROAMJSSLN PVT. LTD.
                Here are the ticket details for your upcoming trip from{" "}
                {deatil?.boardingPoint?.name} to {deatil?.droppingPoint?.name}{" "}
                on {deatil?.journeyDetails?.dayOfWeek} ({deatil?.tripType}),{" "}
                {new Date(deatil?.journeyDetails?.date).toLocaleDateString()}.
              </p>
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                margin: "14px",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "6px",
                  borderBottom: "0.5px solid #087bc9",
                  color: "#414040",
                  backgroundColor: "#97ccf0",
                }}
              >
                Bus Details
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  padding: "12px",
                }}
              >
                <img src="/Assets/bus_10.png" style={{ width: "35px" }} />
                <div>
                  <p style={{ fontSize: "16px", fontWeight: "700" }}>
                    {deatil?.bus?.busName}
                  </p>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "grey",
                    }}
                  >
                    No:{deatil?.bus?.busNumber} ({deatil?.bus?.busType})
                  </p>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#087bc9",
                    }}
                  >
                    {deatil?.isInstantBooking ? "BOOKING NO:" : "PNR NO:"}{" "}
                    {deatil?.pnr}
                  </p>
                </div>
              </div>

              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "6px",
                  borderBottom: "0.5px solid #087bc9",
                  color: "#414040",
                  backgroundColor: "#97ccf0",
                }}
              >
                Journey Details
              </p>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#53b6f0",
                  margin: "15px 0px",
                }}
              >
                <p style={{ fontSize: "12px" }}> Boarding Point</p>
                <p style={{ fontSize: "16px", color: "#043c85" }}>
                  <img src="/Assets/bus-ic.png" style={{ width: "20px" }} />
                  {deatil?.boardingPoint?.name}
                </p>

                <p
                  style={{
                    fontSize: "12px",
                    color: "#224d86",
                    fontWeight: "400",
                  }}
                >
                  {deatil?.boardingPoint?.address}
                </p>
              </p>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#53b6f0",
                  margin: "15px 0px",
                }}
              >
                <p style={{ fontSize: "12px" }}> Dropping Point</p>
                <span style={{ fontSize: "16px", color: "#043c85" }}>
                  <img src="/Assets/bus-ic.png" style={{ width: "20px" }} />{" "}
                  {deatil?.droppingPoint?.name}
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#224d86",
                    fontWeight: "400",
                  }}
                >
                  {deatil?.droppingPoint?.address}
                </p>
              </p>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#043c85",
                  margin: "15px 0px",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#53b6f0",
                  }}
                >
                  {" "}
                  Journey Date and Time
                </p>
                <img src="/Assets/date.png" style={{ width: "20px" }} />
                {new Date(deatil?.journeyDetails?.date).toLocaleDateString()}
                {"  "},{deatil?.journeyDetails?.departureTime} -
                {deatil?.journeyDetails?.arrivalTime} (time slote{" "}
                {deatil?.journeyDetails?.timeSlotSequence}){}
              </p>

              <p
                style={{
                  textAlign: "center",
                  fontWeight: "700",
                  padding: "10px",
                  backgroundColor: "rgb(218, 245, 252)",
                  color: "#087bc9",
                  margin: "10px",
                }}
              >
                {deatil?.tripType === "oneWay"
                  ? "ONWARD JOURNEY"
                  : "ROUND JOURNEY"}
              </p>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  margin: "10px 0px",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#53b6f0",
                  }}
                >
                  {" "}
                  Ticket Price
                </p>
                <span>
                  {" "}
                  <img src="/Assets/ticket-10.png" style={{ width: "20px" }} />
                  {"  "}₹{" "}
                  {Number(deatil?.pricing?.payableAmount || 0).toFixed(2) *
                    (deatil?.tripType === "oneWay" ? 1 : 2)}{" "}
                  /-
                </span>
                <span
                  style={{
                    borderRadius: "7px",
                    fontSize: "10px",
                    padding: "2px",
                    backgroundColor:
                      deatil?.paymentStatus !== "success"
                        ? "rgb(59, 59, 59)"
                        : "#33b966ff",
                    color: "white",
                  }}
                >
                  {deatil?.paymentStatus}
                </span>
              </p>

              <div>
                {deatil?.paymentStatus !== "success" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      padding: "6px",
                      borderRadius: "10px",
                      backgroundColor: "#facc86ff",
                    }}
                  >
                    <p>Make Payment to Download Ticket</p>
                    <p
                      style={{
                        cursor: "pointer",
                        padding: "5px",
                        borderRadius: "10px",
                        backgroundColor: "#23b6aaff",
                        color: "white",
                      }}
                      onClick={() => handlePayment(deatil?._id)}
                    >
                      Pay now
                    </p>
                  </div>
                )}
              </div>

              <p
                style={{
                  borderBottom: "1px solid gray",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#087bc9",
                }}
              >
                PASSENGERS
              </p>
              {Array.isArray(deatil?.seats) && deatil?.seats?.length > 0 ? (
                deatil?.seats?.map((i, ind) => (
                  <p
                    style={{
                      padding: "8px",
                      backgroundColor: "rgb(218, 245, 252)",
                      borderRadius: "6px",
                      margin: "4px",
                      fontSize: "12px",
                      fontWeight: "500",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        paddingLeft: "20px",
                        fontSize: "15px",
                        fontWeight: 700,
                      }}
                    >
                      {ind + 1}.
                      <img
                        src={
                          i?.passenger?.gender === "Male"
                            ? "/Assets/man-1.png"
                            : "/Assets/lady-1.png"
                        }
                        style={{
                          width: "30px",
                          height: "25px",
                          margin: "0px 10px",
                        }}
                      />
                      {i?.passenger?.fullName?.length > 15
                        ? `${i.passenger.fullName.slice(0, 15)}...`
                        : i?.passenger?.fullName}
                      ({i?.passenger?.gender})
                    </span>
                    <span style={{ fontWeight: "600" }}>
                      {" "}
                      Seat: {i?.seatNumber}
                    </span>

                    <span style={{ paddingLeft: "20px" }}>
                      Fare :{" "}
                      <span style={{ fontWeight: "700" }}>
                        ₹{i?.fare.toFixed(2)}
                      </span>
                    </span>
                  </p>
                ))
              ) : (
                <p>
                  No seat booked{" "}
                  {deatil?.isInstantBooking && "(Instant Booking)"}
                </p>
              )}
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                margin: "14px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  height: "fit-content",
                  minHeight: "fit-content",
                  maxHeight: "50vh",
                  overflowY: "auto",
                  backgroundColor: "#ffffff",
                }}
              >
                <p
                  style={{
                    padding: "8px",
                    borderBottom: "0.4px solid grey",
                    fontWeight: "600",
                    color: "#024379",
                  }}
                >
                  Cancellation Policy
                </p>
                <p>
                  Your current cance lation charges according to the cance
                  lation policy is highlighted below
                </p>
                <p style={{ fontSize: "14px", padding: "8px 0px" }}>
                  Cancellation made 24 hours before departure will incur a 10%
                  fee.no refunds for cancellations within 24 hours of departure.
                </p>
                <p style={{ fontSize: "14px" }}>
                  <ul style={{ paddingLeft: "20px", listStyleType: "disc" }}>
                    <li>
                      {" "}
                      Cancelation charges are computed on per seat basis.
                    </li>

                    <li>
                      For Group bookings, cancelation of individual seats is not
                      a lowed.
                    </li>
                    <li>
                      Note: Cancelation charges mentioned above are excluding
                      GST.
                    </li>
                  </ul>
                  <p style={{ fontWeight: "600" }}>
                    How to cancel your ticket on ROAMJSSLN PVT. LTD app
                  </p>
                  Go to my bookings and choose the journey and cancel the ticket
                </p>
              </div>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Total Seats:{deatil?.seats?.length}
              </p>
              <p style={{ fontSize: "17px", fontWeight: "700" }}>
                Total Paid:₹
                {Number(deatil?.summary?.totalAmount.toFixed(2)) *
                  (deatil?.tripType === "oneWay" ? 1 : 2)}
                /-
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Payment Status: {deatil?.summary?.paymentStatus}(
                {deatil?.paymentMethod})
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Booking Status:{deatil?.summary?.status}
              </p>
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                margin: "14px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  height: "fit-content",
                  minHeight: "fit-content",
                  maxHeight: "50vh",
                  overflowY: "auto",
                  backgroundColor: "#ffffff",
                }}
              >
                <p
                  style={{
                    padding: "8px",
                    borderBottom: "0.4px solid grey",
                    fontWeight: "600",
                    color: "#024379",
                  }}
                >
                  Date Change
                </p>
                <p>
                  The journey date for this ticket can be changed, you can
                  advance or postpone the ticket to a different date as per your
                  convenience
                </p>
                <p style={{ fontSize: "14px", padding: "8px 0px" }}>
                  Date change time and charges for this operator is shown below.
                </p>
                <p style={{ fontWeight: "700" }}> No Such Rules are set now</p>
                <p style={{ fontSize: "14px" }}>
                  Note: Rescheduling a ticket can be availed only once per
                  booking, if applicable. Once the travel date change option is
                  availed, the ticket cannot be further cance led.
                  <p style={{ fontWeight: "600" }}>
                    How to cancel your ticket on ROAMJSSLN PVT. LTD app
                  </p>
                  Go to my bookings and choose the journey and cancel the ticket
                </p>
              </div>
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                margin: "14px",
              }}
            >
              <p
                style={{
                  padding: "8px",
                  borderBottom: "0.4px solid grey",
                  fontWeight: "600",
                  color: "#024379",
                }}
              >
                Terms and conditions
              </p>
              <div
                style={{ fontSize: "12px", lineHeight: "1.5" }}
                dangerouslySetInnerHTML={{ __html: termsData }}
              />
            </div>

            <p
              style={{
                fontSize: "12px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Ticket generated At :
              {new Date(deatil?.createdAt).toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
              })}
              {}
            </p>
            <p
              style={{
                fontSize: "12px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Thank you for choosing ROAMJSSLN PVT. LTD Bus!
            </p>
            <p
              style={{
                fontSize: "12px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Contact Support:roam.travel2@gmail.com
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Tickit;
